import React from "react";

export function AvailableShortly() {
  return (
    <div className={"font-jost flex-center flex-col"}>
      <div className={"mb-2 lg:mb-4"}>
        <img
          src={"/assets/images/refer-a-friend/sand-timer.png"}
          alt={"This feature will be available shortly"}
          className={"size-16 lg:size-20"}
        />
      </div>
      <div className={"mb-4 text-dark-1 text-center text-lg lg:text-[28px] font-semibold leading-6 lg:leading-8"}>
        This feature will be <br className={"lg:hidden"} /> available shortly
      </div>
      <div className={"mb-10 lg:mb-8 text-gray-1 text-center font-normal text-xs lg:text-lg leading-4 lg:leading-6"}>
        Check back later to discover what’s waiting for you
      </div>
      <div className={"h-px w-full lg:w-[694px] bg-black/8"} />
    </div>
  );
}
